import React from "react";
import { useLocation } from "react-router-dom";
import CustomDialog from "../../../../components/Dialog/CustomDialog";
import CompetitorProduct from "../../../../api/models/product/CompetitorProduct";
import { ProductReferenceResponseWithType } from "../../../../api/models/ProductReferenceResponse";
import CompetitorSampleAddFormRequester from "../models/CompetitorSuggestionForm/CompetitorSuggestionFormRequester";
import CompetitorSampleAddFormEmployee from "../models/CompetitorSuggestionForm/CompetitorSuggestionFormEmployee";
import { ProductContext } from "../../../../contexts/ProductContext";

const PRODUCT_TAB = "/2";

interface CompetitorSampleAddFormType {
  product: CompetitorProduct | null;
}

export interface CompetitorSuggestionDialogProps {
  preset?: ProductReferenceResponseWithType | null;
  open: boolean;
  onClose: () => void;
  onConfirm: (product: CompetitorSampleAddFormType) => void;
  resetSalesProductInitialData: () => void;
}

const CompetitorSuggestionDialog = ({
  open,
  onClose,
  onConfirm,
  preset,
  resetSalesProductInitialData,
}: CompetitorSuggestionDialogProps) => {
  const { pathname } = useLocation();
  let tabId = "";
  const suggestionFormTemplate = (path: string) => {
    tabId = `${path.charAt(path.length - 2)}${path.charAt(path.length - 1)}`;
    if (tabId === PRODUCT_TAB) {
      if (!preset?.competitorProductId) {
        return (
          <ProductContext.Consumer>
            {(productContext) => {
              const { updateCompetitorCompany, updateCompetitorProduct } = productContext;
              const submitForm = (values: CompetitorSampleAddFormType) => {
                updateCompetitorCompany(values?.product?.company);
                updateCompetitorProduct(values.product);
                onConfirm(values);
              };
              return (
                <CompetitorSampleAddFormEmployee
                  suggestion={preset?.competitorProductName}
                  handleSubmit={submitForm}
                  notFoundLink
                />
              );
            }}
          </ProductContext.Consumer>
        );
      }
      return (
        <ProductContext.Consumer>
          {(productContext) => {
            const { updateCompetitorCompany, updateCompetitorProduct } = productContext;
            const submitForm = (values: CompetitorSampleAddFormType) => {
              updateCompetitorCompany(values?.product?.company);
              updateCompetitorProduct(values.product);
              onConfirm(values);
            };
            return <CompetitorSampleAddFormEmployee disabled preset={preset} handleSubmit={submitForm} />;
          }}
        </ProductContext.Consumer>
      );
    }

    return <CompetitorSampleAddFormRequester preset={preset} handleSubmit={onConfirm} />;
  };

  return (
    <CustomDialog fullWidth maxWidth="sm" onClose={onClose} open={open} onExited={resetSalesProductInitialData}>
      {tabId === PRODUCT_TAB ? <h2>SUGGEST COMPETITOR PRODUCT</h2> : <h2>ADD COMPETITOR PRODUCT</h2>}
      {open && suggestionFormTemplate(pathname)}
    </CustomDialog>
  );
};

export default CompetitorSuggestionDialog;
